import { render } from "./Segment.vue?vue&type=template&id=40feed89"
import script from "./Segment.vue?vue&type=script&lang=js"
export * from "./Segment.vue?vue&type=script&lang=js"
script.render = render

export default script